<template>
  <v-app id="mainApp" dark >
    <div>
      <v-img v-if="this.$root.loadFinish === 0"
        class="se-pre-con black"
        src="@/assets/preloader.gif"
        alt="Preload"
        position="center"
        contain

      ></v-img>
    </div>
    <template v-if="this.$root.loadFinish" >
      <snackbar></snackbar>
      <Navigation :isConnected="this.$root.isConnected" v-on:drawer.native="this.drawer"/>


      <v-main class="black">
        <template v-if="this.$root.isConnected"><Breadcrumb layout-class="pl-3 py-3" /></template>
        <router-view></router-view>
      </v-main>
    </template>
  </v-app>
</template>

<script>

import { mapActions,mapState } from 'vuex';
import Breadcrumb from './components/Breadcrumb';
import Snackbar from './components/Snackbar';
import NotificationMixin from './mixins/NotificationMixin';
import Navigation from './components/home/Navigation';

export default {
  mixins: [NotificationMixin],
  components: {
    Breadcrumb,
    Snackbar,
    Navigation,

  },
  data: () => ({
    timeLoad: 0,
  }),
	methods: {
    ...mapActions({
      userGetData: 'user/data'
    }),
    completeTimeLoad() {
      var time = new Date().getTime();
      if ( (time - this.timeLoad) < 2000) {

        setTimeout(() => {  this.$root.loadFinish= 1; }, (2000 - (time - this.timeLoad)));
      } else {
        this.$root.loadFinish= 1;
      }
    },
  },
  beforeCreate: function(){
    console.log('beforeCreate');

  },
  created: function(){

    this.$root.loadFinish= 0;
    if (!this.$root.isConnected) {
      if(this.$route.name != 'RegenPassword') this.$router.push({ name: `Login` });
    } else {
      if (this.$root.passwordTurnover) {
        this.$router.push({ name: `PasswordTurnover` });
      }
    }
  },
  mounted: function(){
    this.timeLoad = new Date().getTime();
    this.userGetData({data: 'access'});

    //setTimeout(() => {  this.$root.loadFinish= 1; }, 2000);
  },
  computed: {
    ...mapState('user', {
      updatedata: 'updatedata',
      error: 'error',
    }),
  },
  watch: {
    error(message) {
      if (message == 'NotConnected') {
        console.log(403);
        this.$root.isConnected = false;
        this.$root.passwordTurnover = false;
        if (! this.$root.originalUrlConnected) this.$root.originalUrlConnected = this.$route;
        if(this.$route.name != 'RegenPassword' && this.$route.name != 'Login') this.$router.push({ name: `Login` });
        this.completeTimeLoad();
      }
    },
    updatedata: function (updatedata) {
      if (updatedata == 'access') {
        this.completeTimeLoad();
      }
    },
  }
};

</script>

<style>

@font-face {
    font-family: 'GothamProBold';
    src: url('/fonts/GothamPro-Bold.eot');
    src: url('/fonts/GothamPro-Bold.eot') format('embedded-opentype'),
         url('/fonts/GothamPro-Bold.woff2') format('woff2'),
         url('/fonts/GothamPro-Bold.woff') format('woff'),
         url('/fonts/GothamPro-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'GTAmericaRegular';
    src: url('/fonts/GT-America-Expanded-Regular.eot');
    src: url('/fonts/GT-America-Expanded-Regular.eot') format('embedded-opentype'),
         url('/fonts/GT-America-Expanded-Regular.woff2') format('woff2'),
         url('/fonts/GT-America-Expanded-Regular.woff') format('woff'),
         url('/fonts/GT-America-Expanded-Regular.ttf') format('truetype');
}

.familyGothamPro {
  font-family: GothamProBold;
}
.familyGTAmerica {
  font-family: GTAmericaRegular;
}

/* Hide scrollbar for Chrome, Safari and Opera */
html::-webkit-scrollbar {
 display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
html {
 -ms-overflow-style: none;  /* IE and Edge */
 scrollbar-width: none;  /* Firefox */
}
main {
 background-image: url("/fond.png");
 background-repeat: repeat;
 background-color: #cccccc;
}

a {
	text-decoration: none;
}
h1 > .v-icon {
	margin-right: 10px;
}

.toolbartitle_50  {
  max-width: 50%;
}

.routerLink {
  color: white!important;
}
.se-pre-con {
	position: fixed;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	z-index: 9999;
}
.cursorpointer {
  cursor: pointer;
}

.v-image__image--preload {
  filter: none !important;
}

.nobackground  {
  background-color: transparent !important;

}
.background_color_white {
  background-color: white;
}
.tablehtmleditor td{
  border: thin solid rgba(255, 255, 255, 0.12);
  margin: 1px;
}
.tableWrapper td{
  border: thin solid rgba(255, 255, 255, 0.12);
  margin: 1px;
}
.word-nobreak {
  word-break: normal !important;
}
</style>
